module.exports = __webpack_public_path__ + "img/unity.8369127e.webp";